module.exports = __webpack_public_path__ + "assets/img/star-bg.624c9580.png";